<table class="subwindow" plessTitleWindowSub [windowMovable]="false" [windowResizable]="false" [frontDispFlag]="false" cdkDrag [cdkDragConstrainPosition]="constrainPosition">
	<tr class="subwindow-title" cdkDragHandle>
		<th class="window-title-name">受注コード指定選定解除</th>
	</tr>
	<tr class="subwindow-body">
		<td>
			<div class="contents-area">
				<div class="element-column">
          <label class="alert-label">※選定解除するときはチェックを外し設定ボタンを押下してください</label>
					<div class="column-list">
						<label class="list-input-title">選定解除対象</label>
						<div class="list-input-content">
							<input type="text" value="{{this.kymw1318Model.target}}" [style.width.rem]="53" readonly>
						</div>
					</div>

					<wj-flex-grid #dtg_targetList id="dtg_targetList" [style.max-width.px]="844" [style.height.px]="220" [style.max-height.px]="220"
						[itemsSource]="this.kymw1318Model.displayList" [headersVisibility]="'Column'" [allowSorting]="false"
						sortableColumns="false" [allowDragging]="'None'" [selectionMode]="'Row'" [isReadOnly]="true" [allowMerging]="'ColumnHeaders'"
						[allowResizing]="'Columns'" [frozenColumns]="1">
						<wj-flex-grid-column [header]="'媒体'" [binding]="'mediumName'" [width]="375" [minWidth]="5" [isReadOnly]="true" [align]="'left'"></wj-flex-grid-column>
						<ng-template ngFor let-data [ngForOf]="this.kymw1318Model.orderCodeList" let-i="index">
							<wj-flex-grid-column [header]="this.kymw1318Model.orderCodeList[i]" [width]="colWidth" [minWidth]="5" [isReadOnly]="true" [align]="'center'">
								<ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
									<input type="checkbox" [(ngModel)]="this.kymw1318Model.displayMap[cell.item.mediumType][i].checked"
										[tabindex]="-1" *ngIf="this.kymw1318Model.displayMap[cell.item.mediumType][i].isDisplayCheckBox"
										(click)="eventCheckbox_CLICKHandler()" id="OrderCodeSettings_{{cell.col.index}}_{{cell.row.index}}"
                    [disabled]="this.kymw1318Model.displayMap[cell.item.mediumType][i].isDisabledCheckBox"/>
								</ng-template>
							</wj-flex-grid-column>
						</ng-template>
					</wj-flex-grid>
				</div>
			</div>
		</td>
	</tr>

	<tfoot cdkDragHandle>
		<tr>
			<td>
				<div class="footer-buttons">
					<button id="btn_Set" #btn_Set class="btn-primary" (click)="clickSettingButton()" 
						forcedEnabledMode="" [tabindex]="0">設定</button>
				</div>
				<div class="window-title-close">
					<!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
					<button [tabindex]="0" (click)="onClickClose()"></button>
				</div>
			</td>
		</tr>
	</tfoot>
</table>
